<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header">
        <h6 class="modal-title" translate>
            TITLE.TITLE_ENTER_SHIFT_SETUP
        </h6>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">
        <ErrorSummary [ErrorList]="FormErrors"></ErrorSummary>
        <div class="row mb-2">
            <div class="col-5 text-left" [hidden]="masterService.LoggedInUserData.Properties.length < 2">
                <label for="Property" translate>LBL.PROPERTY</label>
            </div>
            <div class="col-7">
                <select class="custom-select w-100" id="Property" [(ngModel)]="Model.PropertyId" [hidden]="masterService.LoggedInUserData.Properties.length < 2" (change)="GetDepartmentList()">
                    <option *ngFor="let row of PropertyList" [ngValue]="row.PropertyId">{{row.PropertyName}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-5 text-left">
                <label translate>LBL.DEPARTMENT</label>
            </div>

            <!--  TWER.SELECT_DEPARTMENT-->
            <!-- </select>-->

            <div class="col-7">
                <select class="custom-select w-100" id="DeptList" [(ngModel)]="Model.DeptId" name="DeptList">
                    <option [ngValue]="0" translate>CMB_DEF.CMB_DEF_CHOOSE_DEPT</option>
                    <option *ngFor="let row of DeptList" [ngValue]="row.Id">{{row.Name}}</option>
                </select>
            </div>
        </div>

    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="ChangeDept()" translate>BTN.BTN_OK</button>
        <button type="button" class="btn btn-secondary" (click)="d('dismiss')" translate>BTN.BTN_CANCEL</button>
    </div>
</ng-template>
